export default {
  FETCH_TICKET_BRAND: 'fetch-ticket-brand', // ticket brand 선택시 호출할 event bus
  FETCH_INCIDENT_LIST: 'fetch-incident-list', // ticket의 incidents list 호출
  OPEN_TICKET_MERGE_DIALOG: 'open-ticket-merge-dialog',
  OPEN_TICKET_LIST_HEADER_CUSTOMIZE_DIALOG: 'open-ticket-list-header-customize-dialog',
  CREATE_EVENT_VIEW: 'create-event-view',
  EDIT_EVENT_VIEW: 'edit-event-view',
  TICKET_BASIC_EXCEL_DOWNLOAD: 'ticket_basic_excel_download',
  UNSELECT_TASK_TYPE: 'unselect_task_type',
  REFRESH_DASHBOARD: 'refresh-dashboard',
  OPEN_MESSAGE_DETAIL_DIALOG: 'open-message-detail-dialog',
  REFRESH_TICKET_COUNT: 'refresh-ticket-count',
  OPEN_TICKET_BATCH_DIALOG: 'open-ticket-batch-dialog',
  OPEN_TICKET_MEMO_HISTORY_DIALOG: 'open-ticket-memo-history-dialog'
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/enums/eventType.js